import React from 'react';
import styles from './SearchBar.module.scss';
import Image from 'next/image';

interface SearchBarProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    searchIcon: string; // Add this line for the searchIcon prop
}

const SearchBar: React.FC<SearchBarProps> = ({ searchIcon, value, onChange, placeholder = "Search..." }) => {
    return (
        <div className={styles.searchBar}>
            <Image src={searchIcon} alt="Search" width={20} height={20} />
            <input
                type="text"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
            />

        </div>
    );
};

export default SearchBar;
